import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, FilterOption, SearchAppState, SearchState } from '../search-model';
import { completeUpdate, updateFilter } from '../search-slice';

interface FilterProps {
	name: string,
	options: FilterOption[],
	defaultValue: FilterOption;
	label: string;
}

export const RadioFilter = (props: FilterProps) => {

	const state = useSelector<SearchAppState, SearchState>(a => a.searchState);
	const hasFilters = state && state.filters && state.filters[props.name]?.filterOptions[0].filterValue;

	const [value, setValue] = useState(hasFilters ? state.filters[props.name]?.filterOptions[0].filterValue : props.defaultValue.filterValue);
	const dispatch = useDispatch();

	const handleChange = (event) => {
		setValue(event.target.value);
		const newFilter: Filter = {
			filterKey: props.name,
			filterOptions: props.options.filter(a => a.filterValue === event.target.value),
			partialMatch: false,
		};
		dispatch(updateFilter(newFilter));
		dispatch(completeUpdate());
	};

	return (

		<FormControl component='fieldset'>
			<legend className='h4-styled'>{props.label}</legend>
			<RadioGroup aria-label={props.label} name={props.name} value={value} onChange={handleChange}>
				{
					props.options.map(a => {
						return <FormControlLabel className='input-label' key={a.filterValue} value={a.filterValue} control={<Radio />} label={a.filterDisplayValue} />;
					})
				}
			</RadioGroup>
		</FormControl>
	);

};